/*
 * Ported verbatim from the legacy app's scripts/app/components/read-progress.js.
 */

(function ($) {

    var winHeight,
        headerHeight,
        contentHeight,
        progressBar = $('.progress-bar'),
        max, value;

    function initprogressbar() {
        winHeight = $(window).height();
        headerHeight = $('.header-wrapper').height();
        contentHeight = $('.page-content-page').find('.page-data').height();
        max = contentHeight + headerHeight - winHeight;
        progressBar.attr('max', max);
    }

    $(function () {
        initprogressbar();

        $(document).on('scroll', function () {
            value = $(window).scrollTop();
            progressBar.css('width', ((value / max) * 100) + '%');
        });

        $(window).on('resize', function () {
            initprogressbar();
        });
    });

})(window.jQuery);
